// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2Zoi7","copyright":"Footer_copyright__3F7Me"};